export type RealtimeTranscriptEvent = {
  type: string;
  item_id?: string;
  delta?: string;
  transcript?: string;
};

type TranscriptItem = {
  text: string;
  completed: boolean;
};

export type RealtimeTranscriptState = {
  order: string[];
  items: Record<string, TranscriptItem>;
};

export const emptyRealtimeTranscript = (): RealtimeTranscriptState => ({
  order: [],
  items: {},
});

export const reduceRealtimeTranscript = (
  state: RealtimeTranscriptState,
  event: RealtimeTranscriptEvent,
): RealtimeTranscriptState => {
  const itemId = event.item_id;
  if (!itemId) return state;

  const existing = state.items[itemId];
  const isNew = !existing;

  if (event.type === 'input_audio_buffer.committed' && isNew) {
    return {
      order: [...state.order, itemId],
      items: {
        ...state.items,
        [itemId]: {
          text: '',
          completed: false,
        },
      },
    };
  }

  if (
    event.type === 'conversation.item.input_audio_transcription.delta'
    && typeof event.delta === 'string'
  ) {
    return {
      order: isNew ? [...state.order, itemId] : state.order,
      items: {
        ...state.items,
        [itemId]: {
          text: `${existing?.text || ''}${event.delta}`,
          completed: false,
        },
      },
    };
  }

  if (
    event.type === 'conversation.item.input_audio_transcription.completed'
    && typeof event.transcript === 'string'
  ) {
    return {
      order: isNew ? [...state.order, itemId] : state.order,
      items: {
        ...state.items,
        [itemId]: {
          text: event.transcript,
          completed: true,
        },
      },
    };
  }

  return state;
};

export const realtimeTranscriptText = (
  state: RealtimeTranscriptState,
): string => state.order
  .map(itemId => state.items[itemId]?.text.trim())
  .filter(Boolean)
  .join(' ');
